import { useMemo } from "react";

import { PaymentMethod } from "@/lib/gql/__generated__/graphql";

import type * as Repository from "../repository";
import type * as Type from "../type";

type QueryData = Repository.Query.QueryData.ReservationRequestList;
type SearchModel = Type.SearchModel;

type Props = {
	queryData: QueryData;
	searchModel: SearchModel;
};

type Result = {
	queryData: QueryData;
};

export const useFilteredQueryDataBySearchModel = ({ queryData: _queryData, searchModel }: Props): Result => {
	/**
	 * メルマガ配信希望者の予約に絞り込む
	 */
	const filteredQueryDataByIsAcceptMailMagazine = useMemo(() => {
		const isAcceptMailMagazine = searchModel.isAcceptMailMagazineChecked;
		if (!isAcceptMailMagazine) return _queryData;

		const filtered = _queryData.reservationList.filter(({ isAcceptMailMagazine }) => isAcceptMailMagazine);

		return {
			..._queryData,
			reservationList: filtered,
		};
	}, [searchModel.isAcceptMailMagazineChecked, _queryData]);
	/**
	 * 現地決済者の予約に絞り込む
	 */
	const filteredQueryDataByIsLocalPayment = useMemo(() => {
		const isLocalPayment = searchModel.isLocalPaymentChecked;
		if (!isLocalPayment) return filteredQueryDataByIsAcceptMailMagazine;

		const filtered = filteredQueryDataByIsAcceptMailMagazine.reservationList.filter(
			(reservation) => reservation.paymentMethod === PaymentMethod.Local,
		);

		return {
			...filteredQueryDataByIsAcceptMailMagazine,
			reservationList: filtered,
		};
	}, [searchModel.isLocalPaymentChecked, filteredQueryDataByIsAcceptMailMagazine]);
	return {
		queryData: filteredQueryDataByIsLocalPayment,
	};
};
